'use client';

import React from 'react';
import type { PageType } from '@/features/Analytics';
import { BookingOnline } from '@/features/Booking';
import { useDoctor } from '../../model/store';
import type { IBookingDoctorData } from '@/entities/booking/model/types';
interface Props {
  bookingData: IBookingDoctorData[];
  pageType: PageType;
}
export const DoctorBookingOnline: React.FC<Props> = ({
  bookingData,
  pageType
}) => {
  const {
    doctorId,
    doctorName,
    medcenterId,
    medcenterName
  } = useDoctor();
  return <BookingOnline bookingData={bookingData} doctorId={doctorId!} doctorName={doctorName} medcenterId={medcenterId} medcenterName={medcenterName} pageType={pageType} data-sentry-element="BookingOnline" data-sentry-component="DoctorBookingOnline" data-sentry-source-file="DoctorBookingOnline.tsx" />;
};